export default __webpack_public_path__ + "static/media/address-pc.5e0ffe67.jpg";